import { useEffect } from 'react';
import { Outlet, useNavigate, useLocation } from 'react-router-dom';

import { ROUTES } from '@/router/routes';
import { CaseToGrade } from '@/api/cases';

import { HeadingGradeFlow } from '@/components/grading/grade-flow/heading-flow';

type DrInsightsFlowProps = {
  selectedCase?: CaseToGrade;
};

export function DrInsightsFlow({ selectedCase }: DrInsightsFlowProps) {
  const navigate = useNavigate();
  const location = useLocation();

  useEffect(() => {
    if (!selectedCase) {
      navigate(ROUTES.INSIGHTS);
      return;
    }

    if (location.pathname.endsWith('/dr-form')) {
      navigate('questions', { replace: true });
    }
  }, [selectedCase, navigate, location.pathname]);

  return (
    <>
      <HeadingGradeFlow type="insights-dr-form" />
      <Outlet />
    </>
  );
}
